import gql from "graphql-tag";
const getExcavations = gql(`
query MyQuery {
hasuraExcavation {
Memo
DealID
DealLimit
CommonName
ARFundTermText
AsiaAltDiscount
Asia_Alt_GP_Legal_Entity
Asia_Alt_GP_Legal_Entity_Commitment
CarryRate
ClawBackDate
ClawBackIndemnity
ClawBackTiming
CommitDate
DealCurrency
DealLimitComps
DebtLimit
DebtLimitTerms
Description
FXRate
FeeStepDownDate
FinRepAnnual
FinRepQuarter
FinRepTax
FinalCloseDate
FiscalEnd
GPCommitGF
GPCommitLE
GPEntity
GroupFundSize
HurdleRate
InitialCloseDate
InvDescription
InvEndDate
InvType
LEDomicile
LEFundSize
LEStructure
LETermDate
LETermDescription
LPCommitGF
LPCommitLE
LegalEntity
LiquidDate
LiquidNotes
MFeeDiscount
MFeeInitialBase
MFeeInitialRate
MFeeStepDownBase
MFeeStepDownRate
MFeeStepDownTime
MFeeTerms
Manager
OtherLimits
SOIGrouping
VintageYear
WaterFallTerms
WaterFallType
FolderPath
KeyPersons
FundFamily
AsiaAltCommitmentAllAffiliates
AsiaAltGPLegalEntityCommitment
AsiaAltGPLegalEntity
PEConsortium
CommitmentFirstCommitmentDate
}
}`)
export default getExcavations;
